import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  window.console.log = function () { };
}
const subSiteName = (environment as any)?.SUB_SITE_NAME;
const themeLink = document.getElementById('theme-link') as HTMLLinkElement;
const ISSUER: string | null = (environment as any)?.ISSUER || null;
if (subSiteName) {
  
  const iconLink = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
  
  if (iconLink) {
    iconLink.href = `./assets/icon/favicon-${subSiteName}.ico`;
  }
  if (themeLink) {
      themeLink.href = `./assets/layout/styles/theme/${ISSUER}/${subSiteName}/theme.css`;    
  }
}
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
